import React, { useContext, useMemo, useState } from "react";
import {
  ActionIcon,
  Button,
  Divider,
  Group,
  Modal,
  Radio,
} from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import { useDispatch, useSelector } from "react-redux";
import {
  setCulture,
  setCurrency,
  STATE_CULTURE,
  STATE_CURRENCY,
} from "../../../Actions/cookiesActions";
import Flag from "./Flag";
import { AppContext } from "../../../context";
import Cookies from "universal-cookie";

const useStyles = createStyles((theme) => ({
  modalFooter: {
    marginTop: "2rem",
    display: "grid",
    gridTempalteColumns: "1fr",
    "& button": {
      justifySelf: "end",
    },
    "& small": {
      color: "#323232",
    },
  },
  group: {
    paddingTop: "10px",
  },
}));
const Settings = () => {
  const { config, culture, currency, language } = useSelector((state) => ({
    config: state.config,
    currency: state.cookies[STATE_CURRENCY],
    culture: state.cookies[STATE_CULTURE],
    language: state.language,
  }));
  const { state } = useContext(AppContext);
  const { classes } = useStyles();
  const [opened, setOpened] = useState(false);
  const rdxDispatch = useDispatch();
  const cookies = useMemo(() => new Cookies(), []);

  const showLanguage = (lang) => {
    switch (lang) {
      case "sv-SE":
        return language.Swedish;
      case "de-DE":
        return language.German;
      case "en-US":
        return language.English;
      case "en-GB":
        return language.English;
      case "fr-FR":
        return language.French;
      case "nn-NO":
        return language.Norwegian;
      case "nb-NO":
        return language.Norwegian;
      case "fi-FI":
        return language.Finnish;
      case "da-DK":
        return language.Danish;
      case "it-IT":
        return language.Italian;
      case "es-ES":
        return language.Spanish;
      default:
        return language.Swedish;
    }
  };

  const changeLanguage = (value) => {
    rdxDispatch(setCulture(value, config));
    cookies.set("shop-culture", value);
  };

  return (
    <div className="header__settings-button">
      <ActionIcon
        title={language.Settings}
        aria-label={language.Settings}
        onClick={() => setOpened(true)}
        style={{ background: "transparent" }}
      >
        <Flag culture={culture} />
      </ActionIcon>
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title={language.Settings}
        centered
        closeButtonProps={{ label: language.Close }}
      >
        <Radio.Group
          name={language.Language}
          label={language.Language}
          description={language.ChangeLanguage}
          value={culture}
          onChange={(val) => changeLanguage(val)}
        >
          <Group className={classes.group}>
            {state?.cultures.map((culture) => (
              <Radio
                value={culture.name}
                label={showLanguage(culture.name)}
                key={culture.name}
              />
            ))}
          </Group>
        </Radio.Group>
        {!config?.hideCurrencySelector && (
          <>
            <Divider mt="xl" mb="lg" />
            <Radio.Group
              name={language.Currency}
              label={language.Currency}
              description={language.ChangeCurrency}
              value={currency}
              onChange={(val) => rdxDispatch(setCurrency(val))}
              pb={6}
            >
              <Group className={classes.group}>
                {state?.currencies?.map((currency) => (
                  <Radio
                    value={currency.name}
                    label={currency.name}
                    key={currency.name}
                  />
                ))}
              </Group>
            </Radio.Group>
          </>
        )}
        <div className={classes.modalFooter}>
          <Button className="primaryButton" onClick={() => setOpened(false)}>
            {language.Close}
          </Button>
          <small>Entry Event Sweden AB - {config.version}</small>
        </div>
      </Modal>
    </div>
  );
};

export default Settings;
